export default "/_next/static/images/02afeab01faf92539efee5da39bc609b.jpg";